<template>
    <bot-spinner v-model="spinner" class="bot-upload-images">
        <input
            type="file"
            accept="image/*"
            ref="inputFile"
            class="d-none"
            @change="onImagePreview"
        />
        <figure>
            <v-img
                dark
                :src="src"
                :alt="title"
                :title="title"
                :aspect-ratio="aspectRatio"
                gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.1)"
                @click="openUpload"
            >
                <template v-slot:placeholder>
                    <v-row
                        class="fill-height ma-0"
                        align-items="center"
                        justify="center"
                    >
                        <v-progress-circular
                            indeterminate
                            color="grey lighten-5"
                        ></v-progress-circular>
                    </v-row>
                </template>
            </v-img>
            <figcaption>{{ caption }}</figcaption>
        </figure>
    </bot-spinner>
</template>

<script>
import BotSpinner from "@/components/bot/spinner/bot.spinner.vue";
const cafe = {
    default: {
        key: "/temp",
        src: "/public/images/templates/avatar-default.png",
        sp: {
            snb: "views/snackbar/show",
            authen: {
                upload: "authen/upload",
            },
        },
        maxSize: 6 * 1024, //6MB
    },
    sms: {
        img_only: "Chỉ cho phép upload ảnh jpg hoặc png!",
    },
};
const df = cafe.default;

export default {
    name: "bot-upload-images",

    props: ["value"],

    components: {
        "bot-spinner": BotSpinner,
    },

    data() {
        return {
            hrf: this.$options.filters.hrf,
            fii: this.$options.filters.is.image,
            file: null,
            title: "This is the title",
            src: null,
            aspectRatio: "1",
            caption: "Ảnh đại diện",
            spinner: {
                visible: false,
                color: "red",
            },
        };
    },

    mounted() {
        let main = this;
        let { src, caption, title, aspectRatio } = main.value;
        if (src && !src.indexOf("./public")) src = src.substring(1);
        if (!main.src && !this.file) main.src = src || df.src;
        if (!isNaN(aspectRatio)) main.aspectRatio = aspectRatio;
        if (caption) main.caption = caption;
        if (title) main.title = title;
    },

    watch: {
        value: {
            handler(val) {
                if (typeof val !== "object") return;
                let src = val.src || this.src;
                if (!src.indexOf("./public")) src = src.substring(1);
                if (!this.file) this.src = src;
                this.title = val.title || this.title;
                this.caption = val.caption || this.caption;
            },
            deep: true,
        },
    },

    computed: {},

    methods: {
        openUpload() {
            const { inputFile } = this.$refs;
            if (!inputFile) return;
            inputFile.click();
        },
        async onImagePreview() {
            const { inputFile } = this.$refs;
            if (!inputFile) return;
            const { files } = inputFile;
            if (files.length <= 0) return;
            const dp = this.$store.dispatch;
            let file = files[0];
            let isImage = this.fii(file.type);
            let text = cafe.sms.img_only;
            if (!isImage) return dp(df.sp.snb, { text, color: "error" });
            const isLtMax = file.size / 1024 < df.maxSize;
            if (!isImage || !isLtMax) return;
            let img = await this.hrf(file);
            this.src = img.src;
            this.file = file;
            let payload = { src: img.src, file };
            this.$emit("onChange", payload);
        },
        async handleUpload({ key }) {
            let isUpload = !!this.file && !this.src.indexOf("data:image");
            if (!isUpload) return this.src;
            const dp = this.$store.dispatch;
            key = key || df.key;
            let payload = { file: this.file, key, name: this.title };
            this.spinner.visible = true;
            const res_upload = await dp(df.sp.authen.upload, payload);
            let text = res_upload.error;
            if (res_upload.error) {
                dp(df.sp.snb, { text, color: "error" });
                return null;
            }
            let item = res_upload.data[0];
            this.src = item.fileName;
            this.file = null;
            this.spinner.visible = false;

            return this.src;
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
.bot-upload-images .v-image {
    cursor: pointer;
    border-style: inset;
    border-width: 3px;
    border-color: coral;
}

.bot-upload-images figure figcaption {
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// bot.upload.images.vue